export const DEFAULT_ROWS_PER_PAGE = 10;
export const PAGINATION_THRESHOLD_VALUE = 25;
export const MAX_ROWS_PER_PAGE = 100;
